module.exports = __webpack_public_path__ + "img/TelefonicaWeb-Light.dde44ca3.svg";